"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 *
 * @author Jan Gregor
 */


var PriceStatsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceStatsConverter, _DataObjectConverter_);

  function PriceStatsConverter() {
    _classCallCheck(this, PriceStatsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceStatsConverter).apply(this, arguments));
  }

  return PriceStatsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceStatsConverter = PriceStatsConverter;